import { NAMESPACE } from "ui-kit/Datagrid/constants";

export default ({ instanceId }) => `${NAMESPACE}-${instanceId}`;
